export const DEFAULT_TEMPLATES_PAGESIZE = 16;
export const DEFAULT_CAMPAIGNS_PAGESIZE = 10;
export const MAX_RECIPIENTS = 5;
export const DEFAULT_WHITELIST_URL = "https://www.venzapeak.com/support/public_resources/phishing/whitelist/#/";
export const CAMPAIGN_STATUS_STYLES: Record<string, { background: string; color: string }> = {
    Scheduled: { background: "#EAEAEB", color: "#000" },
    Live: { background: "#F0EFFD", color: "#6B5AED" },
    Testing: { background: "#fff7e0", color: "#000" },
    Draft: { background: "#fff7e0", color: "#000" },
    Complete: { background: "#CDE7CF", color: "#2E7D32" },
    Cancelled: { background: "#EAEAEB", color: "#000" },
    Failed: { background: "#FBEAEA", color: "#e03a3e" },
};
export const DIFFICULTY_COLOR: Record<string, { bg: string; color: string }> = {
    Beginner: { bg: "#E6F7FD", color: "#006CA3" },
    Intermediate: { bg: "#fff7e0", color: "#000" },
    Advanced: { bg: "#FBEAEA", color: "#e03a3e" },
};

export const DESKTOP_STEPS: string[] = [
    "phishingManager.campaignSetup.steps.desktop.scenario",
    "phishingManager.campaignSetup.steps.desktop.testConfiguration",
    "phishingManager.campaignSetup.steps.desktop.fullCampaignRecipients",
    "phishingManager.campaignSetup.steps.desktop.deliveryAndSchedule",
    "phishingManager.campaignSetup.steps.desktop.reviewAndStartTest"
];

export const MOBILE_STEPS: string[] = [
    "phishingManager.campaignSetup.steps.mobile.scenario",
    "phishingManager.campaignSetup.steps.mobile.test",
    "phishingManager.campaignSetup.steps.mobile.recipients",
    "phishingManager.campaignSetup.steps.mobile.delivery",
    "phishingManager.campaignSetup.steps.mobile.review"
];

export const CAMPAIGN_LENGTH_LIST = [
    { value: 1, label: "phishingManager.campaignSetup.step4.campaignLength.1Day" },
    { value: 2, label: "phishingManager.campaignSetup.step4.campaignLength.2Days" },
    { value: 3, label: "phishingManager.campaignSetup.step4.campaignLength.3Days" },
    { value: 4, label: "phishingManager.campaignSetup.step4.campaignLength.4Days" },
    { value: 5, label: "phishingManager.campaignSetup.step4.campaignLength.5Days" },
    { value: 6, label: "phishingManager.campaignSetup.step4.campaignLength.6Days" },
    { value: 7, label: "phishingManager.campaignSetup.step4.campaignLength.7Days" },
    { value: 8, label: "phishingManager.campaignSetup.step4.campaignLength.8Days" },
    { value: 9, label: "phishingManager.campaignSetup.step4.campaignLength.9Days" },
    { value: 10, label: "phishingManager.campaignSetup.step4.campaignLength.10Days" }
];